import { scheduleJobsFactory } from '@eas/common-web';
import { ExportTags } from '../../../../common/export-tags';

export const ScheduleJobs = scheduleJobsFactory(ExportTags.SCHEDULE_JOBS_GRID);
